import "core-js/modules/es6.reflect.construct.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import "core-js/modules/es6.array.map.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
var ROW = 4;
var COL = 3;
import classnames from 'classnames';

function goYear(direction) {
  var next = this.state.value.clone();
  next.add(direction, 'years');
  this.setState({
    value: next
  });
}

function chooseDecade(year, event) {
  var next = this.state.value.clone();
  next.year(year);
  next.month(this.state.value.month());
  this.props.onSelect(next);
  event.preventDefault();
}

var DecadePanel = /*#__PURE__*/function (_React$Component) {
  _inherits(DecadePanel, _React$Component);

  var _super = _createSuper(DecadePanel);

  function DecadePanel(props) {
    var _this;

    _classCallCheck(this, DecadePanel);

    _this = _super.call(this, props);
    _this.state = {
      value: props.value || props.defaultValue
    }; // bind methods

    _this.prefixCls = "".concat(props.rootPrefixCls, "-decade-panel");
    _this.nextCentury = goYear.bind(_assertThisInitialized(_this), 100);
    _this.previousCentury = goYear.bind(_assertThisInitialized(_this), -100);
    return _this;
  }

  _createClass(DecadePanel, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var value = this.state.value;
      var _this$props = this.props,
          locale = _this$props.locale,
          renderFooter = _this$props.renderFooter;
      var currentYear = value.year();
      var startYear = parseInt(currentYear / 100, 10) * 100;
      var preYear = startYear - 10;
      var endYear = startYear + 99;
      var decades = [];
      var index = 0;
      var prefixCls = this.prefixCls;

      for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
        decades[rowIndex] = [];

        for (var colIndex = 0; colIndex < COL; colIndex++) {
          var startDecade = preYear + index * 10;
          var endDecade = preYear + index * 10 + 9;
          decades[rowIndex][colIndex] = {
            startDecade: startDecade,
            endDecade: endDecade
          };
          index++;
        }
      }

      var footer = renderFooter && renderFooter('decade');
      var decadesEls = decades.map(function (row, decadeIndex) {
        var tds = row.map(function (decadeData) {
          var _classNameMap;

          var dStartDecade = decadeData.startDecade;
          var dEndDecade = decadeData.endDecade;
          var isLast = dStartDecade < startYear;
          var isNext = dEndDecade > endYear;
          var classNameMap = (_classNameMap = {}, _defineProperty(_classNameMap, "".concat(prefixCls, "-cell"), 1), _defineProperty(_classNameMap, "".concat(prefixCls, "-selected-cell"), dStartDecade <= currentYear && currentYear <= dEndDecade), _defineProperty(_classNameMap, "".concat(prefixCls, "-last-century-cell"), isLast), _defineProperty(_classNameMap, "".concat(prefixCls, "-next-century-cell"), isNext), _classNameMap);
          var content = "".concat(dStartDecade, "-").concat(dEndDecade);
          var clickHandler;

          if (isLast) {
            clickHandler = _this2.previousCentury;
          } else if (isNext) {
            clickHandler = _this2.nextCentury;
          } else {
            clickHandler = chooseDecade.bind(_this2, dStartDecade);
          }

          return /*#__PURE__*/React.createElement("td", {
            key: dStartDecade,
            onClick: clickHandler,
            role: "gridcell",
            className: classnames(classNameMap)
          }, /*#__PURE__*/React.createElement("a", {
            className: "".concat(prefixCls, "-decade")
          }, content));
        });
        return /*#__PURE__*/React.createElement("tr", {
          key: decadeIndex,
          role: "row"
        }, tds);
      });
      return /*#__PURE__*/React.createElement("div", {
        className: this.prefixCls
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-header")
      }, /*#__PURE__*/React.createElement("a", {
        className: "".concat(prefixCls, "-prev-century-btn"),
        role: "button",
        onClick: this.previousCentury,
        title: locale.previousCentury
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-century")
      }, startYear, "-", endYear), /*#__PURE__*/React.createElement("a", {
        className: "".concat(prefixCls, "-next-century-btn"),
        role: "button",
        onClick: this.nextCentury,
        title: locale.nextCentury
      })), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-body")
      }, /*#__PURE__*/React.createElement("table", {
        className: "".concat(prefixCls, "-table"),
        cellSpacing: "0",
        role: "grid"
      }, /*#__PURE__*/React.createElement("tbody", {
        className: "".concat(prefixCls, "-tbody")
      }, decadesEls))), footer && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-footer")
      }, footer));
    }
  }]);

  return DecadePanel;
}(React.Component);

export { DecadePanel as default };
DecadePanel.propTypes = {
  locale: PropTypes.object,
  value: PropTypes.object,
  defaultValue: PropTypes.object,
  rootPrefixCls: PropTypes.string,
  renderFooter: PropTypes.func
};
DecadePanel.defaultProps = {
  onSelect: function onSelect() {}
};


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/rc-calendar/decade/DecadePanel.js